import React, { Component } from 'react';
import { inject } from "mobx-react";

@inject("commonStore")
export default class MainView extends Component {
  render() {
    return (
      <div>
       Main View
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Home/MainView.js